import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef, useState } from 'react';
function useAutoReject(rejectTracking, isModalOpen, trackingCookieValue) {
  const $ = _c(11);
  const [pageUsed, setPageUsed] = useState(false);
  const [userScrolled, setUserScrolled] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => setPageUsed(true);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const bannerRef = useHandleClickOutside(t0);
  let t1;
  if ($[1] !== pageUsed || $[2] !== userScrolled) {
    t1 = () => {
      if (pageUsed) {
        return;
      }
      if (!userScrolled) {
        setUserScrolled(true);
        return true;
      }
      if (userScrolled) {
        setPageUsed(true);
        return false;
      }
    };
    $[1] = pageUsed;
    $[2] = userScrolled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleUserScroll = t1;
  let t2;
  let t3;
  if ($[4] !== handleUserScroll || $[5] !== isModalOpen || $[6] !== pageUsed || $[7] !== rejectTracking || $[8] !== trackingCookieValue) {
    t2 = () => {
      function onScroll() {
        const scrollingSet = handleUserScroll();
        if (!scrollingSet) {
          return;
        }
        document.removeEventListener("scroll", onScroll);
      }
      document.addEventListener("scroll", onScroll);
      let timer;
      if (pageUsed && !isModalOpen && !trackingCookieValue) {
        timer = setTimeout(() => {
          document.removeEventListener("scroll", onScroll);
          rejectTracking();
        }, 60000);
      }
      return () => {
        if (timer) {
          clearTimeout(timer);
        }
        document.removeEventListener("scroll", onScroll);
      };
    };
    t3 = [handleUserScroll, pageUsed, isModalOpen, trackingCookieValue, rejectTracking];
    $[4] = handleUserScroll;
    $[5] = isModalOpen;
    $[6] = pageUsed;
    $[7] = rejectTracking;
    $[8] = trackingCookieValue;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  return bannerRef;
}
function useHandleClickOutside(callback) {
  const $ = _c(3);
  const targetRef = useRef(null);
  let t0;
  let t1;
  if ($[0] !== callback) {
    t0 = () => {
      const handleOnClickOutside = event => {
        if (targetRef.current && !targetRef.current.contains(event.target as Node)) {
          callback();
        }
      };
      document.addEventListener("click", handleOnClickOutside, true);
      return () => {
        document.removeEventListener("click", handleOnClickOutside, true);
      };
    };
    t1 = [callback, targetRef];
    $[0] = callback;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return targetRef;
}
export default useAutoReject;